import React from "react";
import { X, Award, TrendingUp } from "lucide-react";
import CandidateQuestions from "./CandidateQuestions";

const CandidateDetailsModal = ({ candidate, selectedRole, onClose }) => {
  if (!candidate) return null;

  // Prioritize filename as display name (title), show actual name as subtitle
  const displayName = candidate.fileName || candidate.name;
  const showActualName = candidate.actualName && candidate.actualName !== displayName;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-3xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gradient-to-r from-orange-600 to-orange-500 text-white p-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Award className="w-8 h-8" />
            <div>
              <h2 className="text-2xl font-bold">{displayName}</h2>
              {showActualName && (
                <p className="text-orange-100 text-sm">Name: {candidate.actualName}</p>
              )}
              <p className="text-orange-100 text-sm">Candidate Details & Interview Questions</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-white/20 rounded-lg transition-colors"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6">
          {/* Score Card */}
          <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-6 border border-orange-200">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600 mb-1">Evaluation Score</p>
                <div className="flex items-baseline gap-2">
                  <span className="text-4xl font-bold text-orange-600">{candidate.score}</span>
                  <span className="text-xl text-gray-500">/10</span>
                </div>
              </div>
              <div className="text-right">
                <p className="text-sm text-gray-600 mb-1">Ranking</p>
                <div className="flex items-center gap-2">
                  <TrendingUp className="w-5 h-5 text-orange-600" />
                  <span className="text-2xl font-bold text-orange-600">#{candidate.rank}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Fit Assessment */}
          <div className="border border-gray-200 rounded-lg p-4">
            <h3 className="font-semibold text-gray-900 mb-2">Fit Assessment</h3>
            <div className="flex items-center gap-2">
              <div className={`px-3 py-1 rounded-full text-sm font-medium ${candidate.score > 7 ? 'bg-green-100 text-green-700' :
                candidate.score > 5 ? 'bg-yellow-100 text-yellow-700' :
                  'bg-red-100 text-red-700'
                }`}>
                {candidate.score > 7 ? 'High Fit' : candidate.score > 5 ? 'Medium Fit' : 'Low Fit'}
              </div>
            </div>
            {candidate.notes && (
              <p className="mt-3 text-gray-700 text-sm">{candidate.notes}</p>
            )}
          </div>

          {/* Interview Questions Section */}
          <CandidateQuestions
            candidate={candidate}
            selectedRole={selectedRole}
          />
        </div>

        {/* Footer */}
        <div className="border-t border-gray-200 p-4 bg-gray-50">
          <button
            onClick={onClose}
            className="w-full py-2 px-4 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CandidateDetailsModal;
